import _toConsumableArray from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useCallback, useMemo } from 'react';
import { FocusManagerContext } from '../../utilities/focus-manager/context.js';

function FocusManager(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      trapFocusList = _useState2[0],
      setTrapFocusList = _useState2[1];

  var add = useCallback(function (id) {
    setTrapFocusList(function (list) {
      return [].concat(_toConsumableArray(list), [id]);
    });
  }, []);
  var remove = useCallback(function (id) {
    var removed = true;
    setTrapFocusList(function (list) {
      var clone = _toConsumableArray(list);

      var index = clone.indexOf(id);

      if (index === -1) {
        removed = false;
      } else {
        clone.splice(index, 1);
      }

      return clone;
    });
    return removed;
  }, []);
  var value = useMemo(function () {
    return {
      trapFocusList: trapFocusList,
      add: add,
      remove: remove
    };
  }, [add, trapFocusList, remove]);
  return (
    /*#__PURE__*/
    React.createElement(FocusManagerContext.Provider, {
      value: value
    }, children)
  );
}

export { FocusManager };